import { locationProps } from '@types';

export const useJitteredLocations = (
  locations: locationProps['locations'],
  offset = 0.0001
): locationProps['locations'] => {
  const grouped = new Map<string, locationProps['locations']>();

  locations.forEach((location) => {
    const lat = Number(location.latitude);
    const lng = Number(location.longitude);
    const key = `${lat},${lng}`;
    if (!grouped.has(key)) grouped.set(key, []);
    grouped.get(key)!.push({ ...location, latitude: lat, longitude: lng });
  });

  const jittered: locationProps['locations'] = [];

  grouped.forEach((group) => {
    if (group.length === 1) {
      jittered.push(group[0]);
    } else {
      const angleStep = (2 * Math.PI) / group.length;
      const [baseLat, baseLng] = [group[0].latitude, group[0].longitude];

      group.forEach((location, index) => {
        const angle = index * angleStep;
        jittered.push({
          ...location,
          latitude: baseLat + offset * Math.cos(angle),
          longitude: baseLng + offset * Math.sin(angle),
        });
      });
    }
  });

  return jittered;
};
